import api from 'api'
import { VerificationType } from 'types/verificationTypes'

export type GetAllRequirementsRequest = {
  requirementId?: number
  nameSubstring?: string
}

export type AdminRequirementRow = {
  id: number
  name: string
  category: string
  credential?: string | null
  verifiable: boolean
  isWorkerVisible: boolean
  verificationType: VerificationType
}

type GetAllRequirementsResponse = {
  data: {
    admin: {
      allRequirements: AdminRequirementRow[]
    }
  }
}

/**
 * Get searchable admin requirement catalog.
 */
export async function getAllPositionRequirements(
  variables: GetAllRequirementsRequest
) {
  const response = await api.post<GetAllRequirementsResponse>(
    '/admin/graphql_dispatch/all_requirements_5bcc9a5a',
    variables
  )
  return response.data.data.admin.allRequirements
}
